import { call, put } from 'redux-saga/effects';

import { createListFromTitle } from 'api/WorkflowsAPI';
import { addNegativeToastWithErrorId, addPositiveToast } from 'modules/toastContainer';
import noop from 'utils/noop';
import { CreateListAction, actions } from '../actions';

export default function* createListSaga({ payload }: CreateListAction) {
  const { title, dispatch, onListCreated = noop, projectId } = payload;
  try {
    const { data } = yield call(createListFromTitle, title, projectId);
    const id = data?.emailList?.id;

    yield put(
      addPositiveToast(`Created "${title}".`, {
        actions: [
          {
            title: 'Open in new tab',
            href: `/segmentation?emailListId=${id}`,
            externalAction: true,
          },
        ],
      }),
    );

    yield call(onListCreated, data?.emailList);
  } catch (error) {
    yield put(
      addNegativeToastWithErrorId('Could not create list.', 'createListSaga', {}, {}, [
        { title: 'Try again?', onClick: () => dispatch(actions.createList(payload)) },
      ]),
    );
  }
}
